import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog,
} from "../types";

export const parentAttributeSection = "/parent-attributes/";

export enum ParentAttributeListUrlFiltersEnum {
  query = "query",
}
export type ParentAttributeListUrlFilters = Filters<ParentAttributeListUrlFiltersEnum>;
export type ParentAttributeListUrlDialog = "remove" | TabActionDialog;
export enum ParentAttributeListUrlSortField {
  name = "name",
  slug = "slug",
}
export type ParentAttributeListUrlSort = Sort<ParentAttributeListUrlSortField>;
export type ParentAttributeListUrlQueryParams = ActiveTab &
  ParentAttributeListUrlFilters &
  ParentAttributeListUrlSort &
  BulkAction &
  Dialog<ParentAttributeListUrlDialog> &
  Pagination;
export const parentAttributeListPath = parentAttributeSection;
export const parentAttributeListUrl = (params?: ParentAttributeListUrlQueryParams) =>
  parentAttributeListPath + "?" + stringifyQs(params);

export type ParentAttributeAddUrlDialog = "add-child" | "edit-child" | "remove-child";
export type ParentAttributeAddUrlQueryParams = Dialog<ParentAttributeAddUrlDialog> & SingleAction;
export const parentAttributeAddPath = urlJoin(parentAttributeSection, "add");
export const parentAttributeAddUrl = (params?: ParentAttributeAddUrlQueryParams) =>
  parentAttributeAddPath + "?" + stringifyQs(params);

export type ParentAttributeUrlDialog = "add-child" | "edit-child" | "remove" | "remove-child";
export type ParentAttributeUrlQueryParams = BulkAction & Dialog<ParentAttributeUrlDialog> & SingleAction;
export const parentAttributePath = (id: string) => urlJoin(parentAttributeSection, id);
export const parentAttributeUrl = (id: string, params?: ParentAttributeUrlQueryParams) =>
  parentAttributePath(encodeURIComponent(id)) + "?" + stringifyQs(params);